import { useMemo, useEffect, useRef, useContext } from "react";
import { SegmentedControl, Stack } from "@mantine/core";
import { useState } from "react";
import renderContentToHtml from "./renderBlocksToHtml";
import { useGetEmailLayout } from "../../api/campaigns";
import { AuthContext } from "../../services/context";
import { getCurrentWorkspace } from "../../services/userConfig";

const WIDTHS = { desktop: 600, mobile: 375 };

const EmailPreview = ({ content }) => {
  const [view, setView] = useState("desktop");
  const iframeRef = useRef(null);

  const { user } = useContext(AuthContext);
  const { eventId } = getCurrentWorkspace(user);

  const { data: layout } = useGetEmailLayout(eventId);

  const bodyHtml = useMemo(() => renderContentToHtml(content), [content]);

  const html = useMemo(() => {
    if (!layout) return bodyHtml;
    return layout.replace("{{body}}", bodyHtml);
  }, [layout, bodyHtml]);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe) {
      const doc = iframe.contentDocument || iframe.contentWindow?.document;
      if (doc) {
        doc.open();
        doc.write(html);
        doc.close();
        doc.querySelectorAll("a[href]").forEach((a) => {
          a.removeAttribute("href");
          a.removeAttribute("target");
          a.style.cursor = "default";
          a.style.pointerEvents = "none";
        });
      }
    }
  }, [html]);

  return (
    <Stack gap="sm">
      <SegmentedControl
        value={view}
        onChange={setView}
        data={[
          { value: "desktop", label: "Desktop" },
          { value: "mobile", label: "Mobile" },
        ]}
        fullWidth
      />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#f5f5f5",
          borderRadius: 8,
          padding: 16,
          minHeight: 400,
        }}
      >
        <iframe
          ref={iframeRef}
          sandbox="allow-same-origin"
          title="Email Preview"
          style={{
            width: WIDTHS[view],
            height: 500,
            border: "1px solid #e0e0e0",
            borderRadius: 4,
            backgroundColor: "#ffffff",
            transition: "width 0.2s ease",
          }}
        />
      </div>
    </Stack>
  );
};

export default EmailPreview;
